module.exports = __webpack_public_path__ + "static/media/tuborg.d15d33f4.svg";